import userImg from '../assets/us1.jpg'
import usersmallImg from '../assets/us2.jpg'
import crown from '../assets/crown.png'
const sliderImages =
{
slide1:<img src={userImg} />,
slide2:<img src={usersmallImg} />,
crownImg:<img src={crown} />,
}
export default sliderImages; 